export default __webpack_public_path__ + "static/media/kadra_ola.a87bf8cf.jpeg";